import { render, staticRenderFns } from "./MobileInsertBar.vue?vue&type=template&id=f0c98012&scoped=true"
import script from "./MobileInsertBar.vue?vue&type=script&lang=js"
export * from "./MobileInsertBar.vue?vue&type=script&lang=js"
import style0 from "./MobileInsertBar.vue?vue&type=style&index=0&id=f0c98012&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0c98012",
  null
  
)

export default component.exports